module.exports = "fuse-navigation{display:flex;flex:1 0 auto}fuse-navigation #main-navigation{margin:0;padding:0;width:100%}\n"